<!--
  name : 김혜진
  desc : 가입한 사용자 레이아웃폼
  date : 2020-10-05
-->
<template>
  <v-app id="bgSt">
    <v-row no-gutters align="center" id="top_bar">
      <v-toolbar-title class="top_bar_logo" @click="goMain"
        >로고</v-toolbar-title
      >
      <v-row no-gutters class="top_bar_nonLayO justfy-end align-center">
        <v-btn class="btn_top_bar btnTBhome" @click="goMain"
          ><span class="icon"></span>서비스 소개</v-btn
        >
      </v-row>
    </v-row>
    <v-card id="navNcon" class="overflow-hidden">
      <s-content class="pd-0"></s-content>
    </v-card>
  </v-app>
</template>
<script>
import SContent from "@/views/layout/components/content";

export default {
  name: "notAuthLayout",
  components: {
    SContent
  },
  filters: {},
  data() {
    return {};
  },

  created() {},
  mounted() {},

  methods: {
    goMain() {
      this.$router.push({ name: "main" });
    }
  }
};
</script>
<style scoped></style>
